/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import { useCartContext } from 'components/Cart/cartContext';
import { isToday } from 'date-fns';
import { Props } from './types';

const WarningLabel: FC<Props> = ({ dayDate }) => {
  const { meals } = useCartContext();

  const orderDatesList: string[] = [];

  // todo: combine1
  Object.entries(meals).forEach(([id, { day }]) => {
    if (orderDatesList.includes(day)) {
      return;
    }

    orderDatesList.push(day);
  });

  const displayIcon = orderDatesList.includes(dayDate);
  const displayTimedWarning = displayIcon && isToday(new Date(dayDate));

  if (displayTimedWarning) {
    return <RunningWithErrorsIcon color="warning" fontSize="small" />;
  }

  if (displayIcon) {
    return <PriorityHighIcon color="warning" fontSize="small" />;
  }

  return null;
};

export default WarningLabel;
